import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import Header from '../components/header'
import '../fonts/fonts.css'
import './video.css'
import './index.scss'
import favicon from '../favicon.ico'

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mobileNavOpen: false
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.mobileNavOpen && prevState.mobileNavOpen) {
      this.setMobileState();
    }
  }

  render() {
    return (
      <div id="content-wrapper" className="outer-wrapper">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Placeholder</title>
          <link rel="icon" href={favicon} />
        </Helmet>
        <div>
          <Header
            isNavActive={this.state.mobileNavOpen}
            setMobileState={this.setMobileState.bind(this)}
            linkData={this.props.data.allContentfulCategory.edges}
            footerData={this.props.data.contentfulFooter} />
          {this.props.children()}
        </div>
      </div>
    )
  }

  setMobileState() {
    this.setState({
      mobileNavOpen: !this.state.mobileNavOpen
    })
  }
}

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
    allContentfulCategory (limit: 100) {
      edges {
        node {
          name
          orderNumber
        }
      }
    }
    contentfulFooter {
      description {
        childMarkdownRemark {
          html
        }
      }
      contactInformation {
        childMarkdownRemark {
          html
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js